import React from "react"
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { formatAdminType, ucFirst } from "../../../util/Helpers";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { Permission } from "./Permission";

export const UserMenu = ({ showReports }) => {
    const history = useHistory();
    const { user } = useSelector(state => state.auth);

    const logoutClick = () => {
        const toggle = document.getElementById("kt_quick_user_toggle");
        if (toggle) {
            toggle.click();
        }
        history.push("/logout");
    };

    return (
        <div
            style={{
                width: "240px"
            }}
            className="rounded-lg bg-dark text-white p-3"
        >
            <div>
                {`${ucFirst(user.firstName)} - ${formatAdminType(user.adminLevel)}`}
            </div>
            <span className="navi-text text-muted text-hover-primary">
                {user.email}
            </span>
            <Permission permission={Permissions.REPORTS} permissionType={PermissionType.READ}>
                <div className="separator separator-dashed my-2" />
                <div onClick={showReports} className="cursor-pointer">Reports</div>
            </Permission>
            <div className="separator separator-dashed my-2" />
            <div onClick={logoutClick} className="text-danger cursor-pointer">Logout</div>
        </div>
    )
}